/**************************************************
 * Nombre:       Home_Resultados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import fondo from '../../../Recursos/fondo_resultados.svg'
import fondo_cel from '../../../Recursos/fondo_celular.svg'
import resultados from '../../../Recursos/img_resultados.png'
import circulo from '../../../Recursos/cirulo.svg'
import {motion, useScroll, useTransform} from "framer-motion";
import Parrafo_fundador from "./Sub_Componentes/Parrafo_fundador";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Resultados = () => {
    const {sCell} = useResponsive()
    const speed = 1 / 12;
    const {scrollY} = useScroll();
    const x = useTransform(scrollY, (value) => -value * speed);

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${sCell ? fondo_cel : fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            }}
        >


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, pt: 23, pb: sCell ? 10 : 6}}
            >


                <Grid container size={{xs: 12, sm: 11, md: 11}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={6}
                    >


                        <Grid container size={{xs: 12, sm: 5, md: 5}} sx={{mt: sCell ? -10 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-end'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                                    <img src={resultados} width={sCell ? '80%' : '100%'} height={'auto'}/>
                                </Grid>

                                <Grid component={motion.div} container size={{xs: 12, sm: 12, md: 6}}
                                      sx={{justifyContent: 'center', mt: -10}}
                                      style={{
                                          y: x,
                                          transitionTimingFunction: "spring(1 100 10 10)",
                                          transition: "transform 3s"
                                      }}
                                >
                                    <img src={circulo} width={sCell ? '30%' : '50%'} height={'auto'}/>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 7, md: 7}} sx={{mt: sCell ? -5 : 0}}>
                            <Parrafo_fundador/>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Resultados

